module.exports = __webpack_public_path__ + "static/img/gg.1ed13d40.svg";